import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        card: {
            display: 'flex',
            alignItems: 'center',
            gap: ['xxxsmall-1.base', 'xxxsmall-1.sm', 'xxxsmall-1.md', 'xxxsmall-1.lg'],
            width: '100%',
        },
        icon: {
            boxSize: remCalc(16),
            flexShrink: 0,
            color: 'foreground.neutral.default',
        },
        textContainter: {
            flex: 1,
            gap: 0,
            alignItems: 'baseline',
            flexWrap: 'wrap',
        },
        strongText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        normalText: {
            textStyle: 'body-small',
            fontWeight: 'medium',
            color: 'foreground.neutral.default',
        },
        infoPopBox: {
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
        },
        infoIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.default',
        },
    },
}
